import React, { useContext, useEffect, useState } from "react";  

import {  
    DashboardAnimation,
    DashboardTitle,
    DashboardText,
    ContentFilterAction,
    ContentFilter,
    ContentTableAction,
    ContentTableActionIcon,
    ContentTableActionIconEdit,
    ContentTableActionIconRemove,
    ContentTableActionIconFile
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import BasicTable from "components/Form/Table";
import Select from "components/Form/Select";
import Button from "components/Form/Button";
import { CoreContext } from "context/CoreContext";
import Input from "components/Form/Input";
import { Read } from "services/cad-quotes";
import { exposeStrapiError, filterNotAllowed } from "utils";

export default function DashboardRegisterQuotes(){  

    const { setModal } = useContext(CoreContext)

    const { searchExpression, setSearchExpression} = useState('')

    const columns = [
        { title:'Nome', ref:'nome_cotista' },
        { title:'CPF / CNPJ', ref:'cpf_cnpj' },
        { title:'Grupo', ref:'grupo_cotista' },
        { title:'Origem', ref:'id_origem' },
        // { 
        //     title: ' ', 
        //     renderCell: ({ row }) => <>
        //         <ContentTableAction>
        //             <Button primary nospace small link onClick={() => null}>
        //                 <ContentTableActionIconRemove />
        //             </Button>
        //             <Button primary nospace small link onClick={() => null}>
        //                 <ContentTableActionIconEdit />
        //             </Button>
        //         </ContentTableAction>
        //     </>  
        // },
    ]
    
    // const rows = [
    //     { name:'Lorem Ipsum.pdf', email:'angelo.santos@icloud.com', found:'Spectra I', profile:'Cotista', status:'Documentação liberada', upload_at: '20/12/2022' },
    //     { name:'Lorem Ipsum.pdf', email:'angelo.santos@icloud.com', found:'Spectra I', profile:'Cotista', status:'Documentação liberada', upload_at: '20/12/2022' },
    //     { name:'Lorem Ipsum.pdf', email:'angelo.santos@icloud.com', found:'Spectra I', profile:'Cotista', status:'Documentação liberada', upload_at: '20/12/2022' },
    //     { name:'Lorem Ipsum.pdf', email:'angelo.santos@icloud.com', found:'Spectra I', profile:'Cotista', status:'Documentação liberada', upload_at: '20/12/2022' },
    //     { name:'Lorem Ipsum.pdf', email:'angelo.santos@icloud.com', found:'Spectra I', profile:'Cotista', status:'Documentação liberada', upload_at: '20/12/2022' },
    //     { name:'Lorem Ipsum.pdf', email:'angelo.santos@icloud.com', found:'Spectra I', profile:'Cotista', status:'Documentação liberada', upload_at: '20/12/2022' }, 
    //     { name:'Lorem Ipsum.pdf', email:'angelo.santos@icloud.com', found:'Spectra I', profile:'Cotista', status:'Documentação liberada', upload_at: '20/12/2022' }, 
    //     { name:'Lorem Ipsum.pdf', email:'angelo.santos@icloud.com', found:'Spectra I', profile:'Cotista', status:'Documentação liberada', upload_at: '20/12/2022' }, 
    // ]


    const [rows, setRows] = useState([ ])
    const [loading, setLoading] = useState(false)
    const [reportOptions, setReportOptions] = useState([ ])
    const [filterReportOptions, setFilterReportOptions] = useState(0)

    const init = async () => { 
        setLoading(true)
        const result = await Read()
        setRows(!(result && !exposeStrapiError(result) && result.length) ? [] : result.map(item => ({
            ...item
        }))) 
        setLoading(false)
    }


    const filterExpression = item => {
        return ( !searchExpression || Object.keys(item)?.filter(filterNotAllowed)?.filter(k => `${ item[k] }`.toLowerCase().indexOf(searchExpression.toLowerCase()) !== -1 ).length > 0)
    }
        
    useEffect(() => {
        init()
    }, [])

    return ( 
        <>
            <ContainerAuthenticated page={"register/quotes"}> 
                <Row>
                    {/* <Col sm={12} md={10} xl={9}> */}
                    <Col sm={12}>
                        <DashboardTitle>
                            Cadastro cotista
                        </DashboardTitle> 


                        <ContentFilterAction>
                            <ContentFilter>
                                <Input placeholder={"Buscar por"} value={searchExpression} onChange={e => setSearchExpression(e.target.value)} />
                            </ContentFilter>
                            <ContentTableAction>
                                {/* <Button primary nospace small onClick={() => setModal({ type:'quote' })}>
                                    Novo Cotista
                                    <ContentTableActionIcon />
                                </Button> */}
                            </ContentTableAction>
                        </ContentFilterAction>


                        {/* 
                            <DashboardText>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ut congue nisl. Duis lobortis ante vitae hendrerit efficitur. Quisque dolor magna, efficitur et nunc id, pretium porta mauris. Integer vel lobortis risus. Duis consectetur ac ante at ullamcorper. Nullam luctus sollicitudin odio, eu gravida lorem efficitur ac. Nam pulvinar consequat cursus. Maecenas convallis sagittis erat, at tristique lectus pharetra et. In eget metus nisl. Maecenas orci ipsum, sagittis non erat eleifend, dignissim suscipit mi. Ut a tellus quis enim pellentesque fringilla. Sed in malesuada felis, eget volutpat neque.
                            </DashboardText>  
                        */}

                        <BasicTable loading={loading} columns={columns} rows={rows?.filter(filterExpression)} />

                    </Col>
                    <Col></Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}